import { render, staticRenderFns } from "./FundingNeeds.vue?vue&type=template&id=970dd2b8"
import script from "./FundingNeeds.vue?vue&type=script&lang=js"
export * from "./FundingNeeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports